import React from 'react';
import '../css/dataTables.css';
import { changeTipoFigura } from '../libs/utils/GlobalFunc';

const renderTableBody = (data, action) => {
    let body = data.map((register, index) => {
        return (
            <tr key={index}>
                <td>{register.CodigoFiguraTransporte || ""}</td>
                <td>{register.NombreFigura || ""}</td>
                <td>{changeTipoFigura(register.TipoFigura.trim()) || ""}</td>
                <td style={{ textAlign: "center", width: 25 }}>
                    <button type="button" className="btn btn-sm" style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }} onClick={() => action(register)}>
                        <i className="fas fa-check"></i>
                    </button>
                </td>
            </tr>
        )
    })
    return body || "";
};

const renderTable = (headers, data, action) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[2].title}</td>
            <td className="sticky-header table-header-yellow " style={{ width: 100 }}></td>
        </tr>;
    }

    body = renderTableBody(data, action);

    let table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header || ""}
                </thead>
                <tbody>
                    {body || ""}
                </tbody>
            </table>
        </div>;
    return table;
};

export const renderTableFiguraTransporteModal = (headers, data, action, checkbox, flagInvoices) => {
    return renderTable(headers, data, action, checkbox, flagInvoices);
}